import * as React from 'react'

// Components
import { SideModalButtons } from 'components/modal'

// Modules
import { DI } from 'modules'

const DownloadSliderWorldExclusive = ({ actions, common, id, onClose }) => {
  const [isUsed, setUse] = React.useState(false)
  const { notifications, videos } = actions
  const { strings = {} } = common

  // Strings
  const prefix = 'page.video.slider.world_exclusive'

  // Handlers
  const handleClick = React.useCallback(() => {
    setUse(true)
    videos.requestWorldExclusive(id).then(res => {
      setUse(false)
      onClose && onClose()
      notifications.createNotification({
        children: strings[`${prefix}.success_message`],
        type: 'success',
      })
    })
  }, [id, notifications, onClose, strings, videos])

  return (
    <SideModalButtons fixed={false}>
      <button
        className="button"
        onClick={handleClick}
        type="button"
        disabled={isUsed}
      >
        {strings[`${prefix}.button_text`]}
      </button>
    </SideModalButtons>
  )
}

export default DI(['notifications', 'videos'])(DownloadSliderWorldExclusive)
